import Palma1 from "../../media/palma/palmagrandia (1).png";
import Palma2 from "../../media/palma/palmagrandia (2).png";
import Palma3 from "../../media/palma/palmagrandia (3).png";
import Palma4 from "../../media/palma/palmagrandia (4).png";
import Palma5 from "../../media/palma/palmagrandia (5).png";
import Palma6 from "../../media/palma/palmagrandia (6).png";
import Palma7 from "../../media/palma/palmagrandia (7).png";
import Palma8 from "../../media/palma/palmagrandia (8).png";
import Palma9 from "../../media/palma/palmagrandia (9).png";
import Palma10 from "../../media/palma/palmagrandia (10).png";
import Palma11 from "../../media/palma/palmagrandia (11).png";
import Palma12 from "../../media/palma/palmagrandia (12).png";

const images = [
  Palma1,
  Palma2,
  Palma3,
  Palma4,
  Palma5,
  Palma6,
  Palma7,
  Palma8,
  Palma9,
  Palma10,
  Palma11,
  Palma12,
];

export default images;
